<template>
  <div
    class="box"
    :style="'top:' + boxPosition + '%'"
  >
    <div class="payment-box">
      <div class="payment-imgTitle">
        <img :src="paymentimgTitle" alt="">
      </div>
      <div class="payment-icon-image">
        <img :src="paymentIntroduction" />
      </div>
      <div class="payment-text">
        <div class="payment-title">
          多種の決済方法をフォロー
        </div>
        <div class="payment-demo">
          Nanacoは“支払い難民”の駆け込み寺！中国に出張・旅行・駐在する日本人が直面しがちなのが決済の悩み！　Nanacoでは多数の決済方法を用意しています。<br />＜WeChat Pay、Alipayのほか、各種クレジットカードをフォロー。チャージカードも用意しています。＞
        </div>
        <div class="payment-function-images">
          <img
            :src="n"
            v-for="(n, index) in paymentIcon"
            :key="index"
          />
        </div>
      </div>
    </div>
    <div class="yello-circle">
      <img :src="paymentcircle" alt="">
    </div>
  </div>
</template>
<script>
import { paymentIntroduction,paymentimgTitle,paymentcircle } from '../../images/home/index'
import { paymentIcon } from '../../images/home/index'
export default {
  data () {
    return {
      boxPosition: '100',
      paymentIntroduction,
      paymentIcon,
      paymentimgTitle,
      paymentcircle
    }
  },
  methods: {
    init () {
      // this.isCanvasShow = true
      // this.$nextTick(() => {
      //   RENDERER.init(document.getElementsByClassName('canvas-area')[0])
      // })

    },
    up () {
      this.boxPosition = '-100'
      // RENDERER.stop()
      // this.isCanvasShow = false
    },
    nomal () {
      this.boxPosition = '0'
      // this.init()
    },
    down () {
      this.boxPosition = '100'
      // RENDERER.stop()
      // this.isCanvasShow = false
    }
  }
}
</script>
<style scoped>
.box {
  background: #313950;
}
.payment-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 0.5rem;
  padding-top: 15%;
  margin: 0 auto;
}
.payment-box {
  display: flex;
}
.payment-icon-image {
  width: 4.5rem;
  position: absolute;
  left: 37%;
  margin-left: -3rem;
  margin-top: -0.5rem;
  z-index: 2;
}
.payment-icon-image img {
  width: 100%;
  height: auto;
  display: block;
}
.payment-text{
  width: 6rem;
  position: absolute;
  left: 50%;
}
.payment-imgTitle{
 text-align: center;
  width: 2.5rem;
  height: 2rem;
  position: absolute;
  top: 0.6rem;
  left: 50%;
  margin-left: -1.5rem;
  z-index: 99;
  
}
.payment-imgTitle img{
  width: 100%;
  height: auto;
}
.payment-title {
  font-weight: bold;
  color: #FFE2B5;
  font-size: 0.45rem;
  margin-bottom: 0.15rem;
  margin-top: -0.5rem;
}
.payment-demo {
  color: #a9afc8;
  font-size: 0.25rem;
  margin-bottom: 0.2rem;
  line-height: 0.45rem;
  letter-spacing: 0.01rem;
  margin-top: 0.4rem;
  letter-spacing: 0.05rem;
}
.payment-function-images {
  margin-top: 1.8rem;
  display: flex;
  justify-content: space-between;
}
.payment-function-images img {
  width: 0.8rem;
  height: 0.8rem;
  display: block;
}
.yello-circle{
  width: 50%;
  height: 50%;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
}
.yello-circle img{
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/home/modules/payment-introduction.vue